<template>
    <div class="w-full">
        <div v-if="view === 'edit'" class="w-full border border-gray-200">
            <div class="p-6">
                <div class="alert alert-warning mb-6 text-sm">
                    <p>&bull; To enter a link to text select the text you want to add the link to.</p>
                    <p>&bull; Drag and drop images where you would like them placed.</p>
                </div>
                <div class="w-full mb-4">
                    <div class="w-full">
                        <label for="strategy">Strategy</label>
                        <select class="form-control form-control-sm form-control-fixed form-input-modal" name="strategy" id="strategy" v-model="form.strategy">
                            <option :value="strategy.value" v-for="strategy in strategies">
                                {{ strategy.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="w-full mb-4">
                    <label for="" class="py-1">Content</label>
                    <w-editor height="12rem" :content="form.content" v-model="form.content"></w-editor>
                    <div v-if="errors.content" class="error">
                        {{ errors.content[0] }}
                    </div>
                </div>

                <div class="w-full mb-4">
                    <label for="" class="py-1">Markets Warning</label>
                    <w-editor height="8rem" :content="form.warning" v-model="form.warning"></w-editor>
                    <div v-if="errors.warning" class="error">
                        {{ errors.warning[0] }}
                    </div>
                </div>

                <div class="flex flex-wrap mb-2">
                    <div class="w-full xs:pl-0">
                        <label for="contract">Contract Name</label>
                        <input :class="{ 'is-invalid' : errors.contract }" id="contract" class="form-input form-input-sm" v-model="form.contract" type="text">
                        <div v-if="errors.contract" class="error">
                            {{ errors.contract[0] }}
                        </div>
                    </div>

                    <div class="w-full xs:pl-0">
                        <label for="description">Description</label>
                        <input :class="{ 'is-invalid' : errors.description }" id="description" class="form-input form-input-sm" v-model="form.description" type="text">
                        <div v-if="errors.description" class="error">
                            {{ errors.description[0] }}
                        </div>
                    </div>

                    <div class="w-full xs:pl-0">
                        <label for="pattern">Pattern</label>
                        <input :class="{ 'is-invalid' : errors.pattern }" id="pattern" class="form-input form-input-sm" v-model="form.pattern" type="text">
                        <div v-if="errors.pattern" class="error">
                            {{ errors.pattern[0] }}
                        </div>
                    </div>

                    <div class="xs:w-full w-1/4 xs:pl-0">
                        <label for="expiration">Expiration Date</label>
                        <input :class="{ 'is-invalid' : errors.expiration }" id="expiration" class="form-input form-input-sm" v-model="form.expiration" type="date">
                        <div v-if="errors.expiration" class="error">
                            {{ errors.expiration[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pl-2 xs:pl-0">
                        <label for="expiration-time">Expiration Time</label>
                        <input :class="{ 'is-invalid' : errors.expiration }" id="expiration-time" class="form-input form-input-sm" v-model="form.expirationTime" type="text">
                        <div v-if="errors.expirationTime" class="error">
                            {{ errors.expirationTime[0] }}
                        </div>
                    </div>

                    <div class="xs:w-full w-1/2 pl-2 xs:pl-0">
                        <label for="market">Indicative Market</label>
                        <input :class="{ 'is-invalid' : errors.market }" id="market" class="form-input form-input-sm" v-model="form.market" type="text">
                        <div v-if="errors.market" class="error">
                            {{ errors.market[0] }}
                        </div>
                    </div>
                </div>

                <div v-if="form.strategy === 'cross-over' || form.strategy === 'nadex'" class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/2 xs:pl-0">
                        <label for="order">Buy/Sell</label>
                        <select class="form-control form-control-sm form-control-fixed form-input-modal" name="order" id="order" v-model="form.order">
                            <option value="Buy">Buy</option>
                            <option value="Sell">Sell</option>
                        </select>
                    </div>
                </div>

                <template v-if="form.strategy === 'volatility' || form.strategy === 'boring'">

                    <fieldset class="p-4 mb-2 rounded-lg border border-gray-200">
                        <strong v-if="form.strategy === 'boring'">Buy</strong>
                        <strong v-if="form.strategy === 'volatility'">Sell</strong>

                        <div class="flex flex-wrap mb-2">
                            <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                                <label for="buyStrike">Strike Price</label>
                                <input :class="{ 'is-invalid' : errors.buyStrike }" id="buyStrike" class="form-input form-input-sm" v-model="form.buyStrike" type="text">
                                <div v-if="errors.buyStrike" class="error">
                                    {{ errors.buyStrike[0] }}
                                </div>
                            </div>
                            <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                                <label for="buyEntryPrice">Average Entry Price</label>
                                <input :class="{ 'is-invalid' : errors.buyEntryPrice }" id="buyEntryPrice" class="form-input form-input-sm" v-model="form.buyEntryPrice" type="text">
                                <div v-if="errors.buyEntryPrice" class="error">
                                    {{ errors.buyEntryPrice[0] }}
                                </div>
                            </div>

                            <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                                <label for="buyTarget">Target Price</label>
                                <input :class="{ 'is-invalid' : errors.buyTarget }" id="buyTarget" class="form-input form-input-sm" v-model="form.buyTarget" type="text">
                                <div v-if="errors.buyTarget" class="error">
                                    {{ errors.buyTarget[0] }}
                                </div>
                            </div>
                        </div>

                    </fieldset>

                    <fieldset class="p-4 mb-2 rounded-lg border border-gray-200">
                        <strong v-if="form.strategy === 'volatility'">Buy</strong>
                        <strong v-if="form.strategy === 'boring'">Sell</strong>

                        <div class="flex flex-wrap mb-2">
                            <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                                <label for="sellStrike">Strike Price</label>
                                <input :class="{ 'is-invalid' : errors.sellStrike }" id="sellStrike" class="form-input form-input-sm" v-model="form.sellStrike" type="text">
                                <div v-if="errors.sellStrike" class="error">
                                    {{ errors.sellStrike[0] }}
                                </div>
                            </div>
                            <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                                <label for="sellEntryPrice">Average Entry Price</label>
                                <input :class="{ 'is-invalid' : errors.sellEntryPrice }" id="sellEntryPrice" class="form-input form-input-sm" v-model="form.sellEntryPrice" type="text">
                                <div v-if="errors.sellEntryPrice" class="error">
                                    {{ errors.sellEntryPrice[0] }}
                                </div>
                            </div>

                            <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                                <label for="sellTarget">Target Price</label>
                                <input :class="{ 'is-invalid' : errors.sellTarget }" id="sellTarget" class="form-input form-input-sm" v-model="form.sellTarget" type="text">
                                <div v-if="errors.sellTarget" class="error">
                                    {{ errors.sellTarget[0] }}
                                </div>
                            </div>
                        </div>

                    </fieldset>
                </template>

                <template v-if="form.strategy === 'cross-over' || form.strategy === 'nadex'">
                    <div class="flex flex-wrap mb-2">
                        <div class="xs:w-full w-1/2 pr-2 xs:pr-0">
                            <label v-if="form.strategy === 'nadex'" for="strike">Nadex Call Spread</label>
                            <label v-else for="strike">Strike Price</label>
                            <input :class="{ 'is-invalid' : errors.strike }" id="strike" class="form-input form-input-sm" v-model="form.strike" type="text">
                            <div v-if="errors.strike" class="error">
                                {{ errors.strike[0] }}
                            </div>
                        </div>
                        <div class="xs:w-full w-1/2 pr-2 xs:pr-0">
                            <label for="price">Average Entry Price</label>
                            <input :class="{ 'is-invalid' : errors.price }" id="price" class="form-input form-input-sm" v-model="form.price" type="text">
                            <div v-if="errors.price" class="error">
                                {{ errors.price[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-wrap mb-2">
                        <div class="xs:w-full w-1/2 pr-2 xs:pr-0">
                            <label for="target">Target Price</label>
                            <input :class="{ 'is-invalid' : errors.target }" id="target" class="form-input form-input-sm" v-model="form.target" type="text">
                            <div v-if="errors.target" class="error">
                                {{ errors.target[0] }}
                            </div>
                        </div>
                    </div>
                </template>

                <div class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/2 pr-2 xs:pr-0">
                        <label class="form-check-label" for="send-notifications">
                            <input id="send-notifications" class="form-check mr-2" v-model="form.sendNotifications" type="checkbox" />
                            Send Notifications
                        </label>
                    </div>
                </div>

                <div class="w-full mt-8">
                    <button @click="preview" class="btn btn-yellow">Preview</button>
                    <a href="/admin" class="text-black ml-2 btn btn-default">Cancel</a>
                </div>
            </div>
        </div>
        <div v-if="view === 'preview'">
            <div class="flex flex-wrap items-center justify-center mb-6">
                <button @click="view = 'edit'" class="btn btn-blue mx-6">Edit</button>
                <button @click="handlePublish" class="btn btn-yellow mx-6">Publish</button>
            </div>

            <div v-html="htmlContent"></div>

            <div class="flex flex-wrap items-center justify-center mt-6">
                <button @click="view = 'edit'" class="btn btn-blue mx-6">Edit</button>
                <button @click="handlePublish" class="btn btn-yellow mx-6">Publish</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const defaultStrategies = [
    { name: 'CrossOver Strategy', value: 'cross-over' },
    { name: 'Volatility Spreads', value: 'volatility', addToForm: true },
    { name: 'The Boring Market Setup', value: 'boring', addToForm: true },
    { name: 'Nadex Spreads', value: 'nadex' },
];
const strategies = ref(defaultStrategies);
const form = ref({
    strategy: defaultStrategies[0].value,
    subject: '',
    content: '',
    description: '',
    contract: '',
    pattern: '',
    order: 'Buy',
    strike: '',
    target: '',
    expiration: '',
    expirationTime: '',
    price: '',
    market: '',
    sendNotifications:  true,
    warning: `<p>Note that I typically don't hold these positions until expiration. I shoot for a specific support/resistance target, and once it's hit I liquidate the position. I also actively manage the positions. So if needed, I may liquidate the position before the target is hit.</p>`,
});

const errors = ref({});
const view = ref('edit');
const htmlContent = ref('');

watch(() => form.strategy, (newStrategy, oldStrategy) => {
    const pStrategy = defaultStrategies.find(s => s.value === newStrategy);

    if (pStrategy && pStrategy.addToForm) {
        const fields = ['Strike', 'EntryPrice', 'Target'];
        fields.forEach((field) => {
            form.value[`buy${field}`] = '';
            form.value[`sell${field}`] = '';
        });
    }
});

function handlePublish() {
    const route = window.route('admin.binary-options.volume-2.publish');
    errors.value = {};
    axios.post(route, form.value)
        .then((response) => {
            window.location = window.route('admin.binary-options.volume-2.index')
        }).catch(error => {
        }).then(() => {
        });
}

function preview() {
    const route = window.route('admin.binary-options.volume-2.preview');
    axios.post(route, form.value)
        .then((response) => {
            htmlContent.value = response.data.html
            view.value = 'preview';
        }).catch(error => {
            errors.value = error.response.data.errors;
        }).then(() => {
        });
}
</script>
